import { get } from 'lodash';
import React from 'react';
import { ANTRAGS_FORMULAREN, PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { TreeNodeType } from '../../../../../../lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import AbschlussAbschlussEmob, { getFormStrucAbschlussAbschlussEmob } from './emob-f-und-e/AbschlussAbschlussEmob';
import BeschreibungenAbschlussEmob, { getFormStrucBeschreibungenAbschlussEmob } from './emob-f-und-e/BeschreibungenAbschlussEmob';
import { GetEffekteDerFoerderungAbschlusEmob } from './emob-f-und-e/effekteDerFoerderung/GetEffekteDerFoerderungAbschlusEmob';
import FazitAbschlussberichtEmob, { getFormStrucFazitAbschlussberichtEmob } from './emob-f-und-e/FazitAbschlussberichtEmob';
import { GetKurzfassungAbschlussEmob } from './emob-f-und-e/kurzfassung/GetKurzfassungAbschlussEmob';
import OeffentlichkeitsarbeitAbschlussEmob, {
	getFormStrucOeffentlichkeitsarbeitAbschlussEmob,
} from './emob-f-und-e/OeffentlichkeitsarbeitAbschlussEmob';
import ProjektergebnisseAbschlussEmob, { getFormStrucProjektergebnisseAbschlussEmob } from './emob-f-und-e/ProjektergebnisseAbschlussEmob';
import AbschlussAbschlussEmobInvest, { getFormStrucAbschlussAbschlussEmobInvest } from './emob-invest/AbschlussAbschlussEmobInvest';
import AlleBerichtFelderAbschlussEmobInvest, {
	getFormStrucAlleBerichtFelderAbschlussEmobInvest,
} from './emob-invest/AlleBerichtFelderAbschlussEmobInvest';

// import schemas
import AbschlussBerichtSchema from '../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = AbschlussBerichtSchema.attributes;

export const TreeStructureAbschlussEmob = (application: any): TreeNodeType[] => {
	let treeNodes: TreeNodeType[] = [];

	if (get(application, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.EmobInvest) {
		treeNodes = [
			{
				label: 'Förderung',
				content: <AlleBerichtFelderAbschlussEmobInvest />,
				formStruc: getFormStrucAlleBerichtFelderAbschlussEmobInvest(),
			},
			{
				label: 'Abschluss',
				content: <AbschlussAbschlussEmobInvest />,
				formStruc: getFormStrucAbschlussAbschlussEmobInvest(),
			},
		];
	}

	if (get(application, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.EmobFundE) {
		treeNodes = [
			{
				label: 'Projektergebnisse',
				content: <ProjektergebnisseAbschlussEmob />,
				formStruc: getFormStrucProjektergebnisseAbschlussEmob(application),
			},
			{
				label: 'Beschreibung',
				content: <BeschreibungenAbschlussEmob />,
				formStruc: getFormStrucBeschreibungenAbschlussEmob(),
			},
			{
				label: 'Öffentlichkeitsarbeit',
				content: <OeffentlichkeitsarbeitAbschlussEmob />,
				formStruc: getFormStrucOeffentlichkeitsarbeitAbschlussEmob(application),
			},
			{
				label: 'Fazit',
				content: <FazitAbschlussberichtEmob />,
				formStruc: getFormStrucFazitAbschlussberichtEmob(),
			},
			{
				label: 'Kurzfassug',
				content: <ApplicationHeading title="Kurzfassung zum Projektende" description={PLATZHALTER_TEXT} />,
				children: GetKurzfassungAbschlussEmob(application),
			},
			{
				label: 'Effekte der Förderung in Unternehmen',
				content: <ApplicationHeading title="Effekte der Förderung im Unternehmen" description={PLATZHALTER_TEXT} />,
				children: GetEffekteDerFoerderungAbschlusEmob(application),
			},
			{
				label: 'Abschluss',
				content: <AbschlussAbschlussEmob />,
				formStruc: getFormStrucAbschlussAbschlussEmob(),
			},
		];
	}

	return treeNodes;
};
